// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Doc = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Doc = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Doc = _exports.Doc = function Doc(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.927 8.49609V16.9268C16.927 17.4779 16.7081 18.0065 16.3184 18.3961C15.9287 18.7858 15.4002 19.0048 14.8491 19.0048H5.15214C4.60104 19.0048 4.07251 18.7858 3.68283 18.3961C3.29314 18.0065 3.07422 17.4779 3.07422 16.9268V3.07402C3.07422 2.52292 3.29314 1.99439 3.68283 1.6047C4.07251 1.21502 4.60104 0.996094 5.15214 0.996094H9.42703C9.79431 0.996149 10.1465 1.14205 10.4063 1.40172L16.5214 7.51687C16.7811 7.7766 16.927 8.12882 16.927 8.49609Z",
      stroke: "#212B36",
      "stroke-width": "1.5",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10 1.3418V6.5366C10 6.904 10.1459 7.25635 10.4057 7.51614C10.6655 7.77593 11.0179 7.92188 11.3853 7.92188H16.5801",
      stroke: "#212B36",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M6.09411 15.6861C7.20206 15.6861 7.8892 15.0025 7.8892 13.8661C7.8892 12.7315 7.20206 12.0497 6.09233 12.0497H4.75V15.6861H6.09411ZM5.62891 14.9368V12.799H6.04794C6.67294 12.799 7.00852 13.0831 7.00852 13.8661C7.00852 14.6527 6.67294 14.9368 6.06037 14.9368H5.62891Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M11.8345 13.8679C11.8345 12.6658 11.0746 12 10.098 12C9.1179 12 8.36328 12.6658 8.36328 13.8679C8.36328 15.0646 9.1179 15.7358 10.098 15.7358C11.0746 15.7358 11.8345 15.07 11.8345 13.8679ZM10.9361 13.8679C10.9361 14.5799 10.6236 14.9652 10.098 14.9652C9.57422 14.9652 9.25994 14.5799 9.25994 13.8679C9.25994 13.1559 9.57422 12.7706 10.098 12.7706C10.6236 12.7706 10.9361 13.1559 10.9361 13.8679Z",
      fill: "#212B36"
    }), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.6484 13.3672C15.5597 12.4972 14.9116 12 14.0327 12C13.0632 12 12.3086 12.6658 12.3086 13.8679C12.3086 15.0646 13.0455 15.7358 14.0327 15.7358C15.0305 15.7358 15.5827 15.0575 15.6484 14.413L14.7607 14.4077C14.6985 14.7575 14.4357 14.9652 14.0504 14.9652C13.532 14.9652 13.2053 14.5906 13.2053 13.8679C13.2053 13.1737 13.5249 12.7706 14.0558 12.7706C14.4553 12.7706 14.7163 13.0032 14.7607 13.3672H15.6484Z",
      fill: "#212B36"
    }));
  };
});
